import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { GenerateAiIconFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface GenerateAiIconFormProps {
  defaultFormValues?: Partial<GenerateAiIconFormValues>;
  children?: React.ReactNode;
}
export const GenerateAiIconForm = ({
  defaultFormValues,
  children,
}: GenerateAiIconFormProps) => {
  const methods = useForm<GenerateAiIconFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
